import ProjectRunConfiguration from "@app/projects/projectRunConfiguration";

export function isHistoricalRun(projectRunConfiguration?: Partial<ProjectRunConfiguration>): boolean {
  if (!projectRunConfiguration) return false;

  return !projectRunConfiguration.isLatestPublished && !!projectRunConfiguration.datePublished;
}
